import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { P0003605ESPInstallationClComponent } from '../../../../P0003605/InjectionChlore/EnSavoirPlus/p0003605-espinstallation-cl/p0003605-espinstallation-cl.component';
import { P0003606ESPInstallationPhComponent } from '../../../../P0003606/EnSavoirPlus/p0003606-espinstallation-ph/p0003606-espinstallation-ph.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P0003600 } from '../../../../P0003600';
import { P0003601 } from '../../../../P0003601';
import { P0004700 } from '../../../../P0004700';
import { P00046 } from '../../../../P00046';
import { P00058 } from '../../../../P00058';
import { P0006600 } from '../../../../P0006600';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00076DureeTypeEnum } from '../../../Enum/P00076DureeTypeEnum';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { InformationTitleComponent } from '../../../../../../../../components/ecosystems/information-title/information-title.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { P00076AjustementTypeEnum } from '../../../Enum/P00076AjustementTypeEnum';

@Component({
  selector: 'app-p00076-constance-parameters',
  templateUrl: './p00076-constance-parameters.component.html',
  styleUrls: ['./p00076-constance-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    TranslatePipe,
    SwitchConfigurationComponent,
    AffichageWarningComponent,
    InformationTitleComponent,
    LargedLinkComponent,
  ],
})
export class P00076ConstanceParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalController: SlideModalController =
    inject(SlideModalController);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async onConsommationPress() {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.Constance_Parametrage,
      'coPResetCompteurConsommation',
      1,
    );
    this.actionStack!.commit();
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00076DureeTypeEnum = P00076DureeTypeEnum;
  protected readonly P00076AjustementTypeEnum = P00076AjustementTypeEnum;
}
